import type { BrandConfig } from './types';

export const amaiConfig: BrandConfig = {
  key: 'amai',
  isDefault: true,
  subdomain: 'amai',
  logo: '/brands/amai/logo.png',
  title: '界墨AI - 领先的AI模型与创作者社区',
  siteName: 'AME AI',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'AME平台付费服务协议',
    productNameKey: 'payment.ameProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'AME平台付费协议', labelKey: 'agreement.tabAmePayment' },
    { key: 'ricegrain-rules', label: '米粒值规则说明', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: '用户协议', labelKey: 'agreement.tabUserAgreement' },
    { key: 'privacy-policy-detail', label: '隐私政策', labelKey: 'agreement.tabPrivacyDetail' },
    { key: 'enterprise-service-agreement', label: '企业服务协议', labelKey: 'agreement.tabEnterprise' },
  ],
  logoDisplay: {
    mode: 'text',
    showGlow: true,
    textStyle: { fontSize: '18px', fontWeight: '500' },
  },
  // 调试：右下角「模拟 gxzs」按钮（仅开发/测试环境渲染），验证 gxzs 站点形态
  showBrandDebugSwitch: true,
};
